<template>
  <div class="min-w-56 xl:min-w-80">
    <label
      :for="attribute"
      class="sr-only"
      v-text="label"
    />
    <AisMenuSelect
      :attribute="attribute"
      :transform-items="transformItems"
      @change="$emit('filterChanged')"
    >
      <template #defaultOption>
        {{ defaultOption }}
      </template>
    </AisMenuSelect>
  </div>
</template>

<script lang="ts" setup>
import { AisMenuSelect } from 'vue-instantsearch/vue3/es'

import { AisMenuListItem } from '@js/types/search/AisMenuListItem'

const props = withDefaults(
  defineProps<{
    label: string
    attribute: string
    defaultOption: string
    shouldTransformItems?: boolean
  }>(),
  {
    shouldTransformItems: true,
  },
)

defineEmits<{
  filterChanged: []
}>()

const transformItems = (items: AisMenuListItem[]) => {
  if (!props.shouldTransformItems) {
    return items
  }

  return items.map(item => ({
    ...item,
    label: item.label
      .replace('-', ' ')
      .toLowerCase()
      .replace(/^\w|\s\w/g, c => c.toUpperCase()),
  }))
}
</script>
